import styles from "../styles/pages.module.css";

export default function Privacidad() {
  return (
    <div className={styles.legalPage}>
      <div className={styles.legalContainer}>
        <h1>Política de Privacidad</h1>
        <span className={styles.lastUpdated}>Última actualización: abril 2026</span>

        <h2>1. Responsable del tratamiento</h2>
        <p>
          El responsable del tratamiento de sus datos personales es <strong>Britosa Mudanzas</strong>, con domicilio en C. Río Duero, 28934 Móstoles, Madrid, y correo electrónico <a href="mailto:info@mudanzasbritosa.com">info@mudanzasbritosa.com</a>.
        </p>

        <h2>2. Datos que recogemos</h2>
        <p>A través de los formularios de contacto y presupuesto de este sitio web recopilamos:</p>
        <ul>
          <li>Nombre y apellidos</li>
          <li>Dirección de correo electrónico</li>
          <li>Teléfono de contacto</li>
          <li>Direcciones de origen y destino de la mudanza</li>
          <li>Fecha prevista del servicio</li>
          <li>Descripción de bienes y servicios requeridos</li>
          <li>Fotografías adjuntas (cuando el usuario las proporcione voluntariamente)</li>
        </ul>

        <h2>3. Finalidad y legitimación</h2>
        <p>
          Tratamos sus datos con las siguientes finalidades:
        </p>
        <ul>
          <li><strong>Gestionar solicitudes de presupuesto y contacto:</strong> para atender su petición, enviarle una estimación de costes y coordinar el servicio de mudanza. La base legitimadora es la ejecución de medidas precontractuales a petición del interesado (art. 6.1.b RGPD).</li>
          <li><strong>Envío de comunicaciones comerciales:</strong> solo si nos ha otorgado su consentimiento expreso marcando la casilla correspondiente. Puede revocarlo en cualquier momento.</li>
          <li><strong>Cumplimiento de obligaciones legales:</strong> en materia fiscal, mercantil y de transporte.</li>
        </ul>

        <h2>4. Plazo de conservación</h2>
        <p>
          Sus datos se conservarán durante el tiempo necesario para cumplir con la finalidad para la que fueron recabados y para determinar las posibles responsabilidades que pudieran derivarse de dicha finalidad y del tratamiento de los datos. En general, conservamos los datos de solicitudes durante <strong>2 años</strong> desde la última interacción, salvo obligación legal de conservación superior.
        </p>

        <h2>5. Derechos del interesado</h2>
        <p>
          Usted tiene derecho a obtener confirmación sobre si en Britosa Mudanzas estamos tratando datos personales que le conciernan. Asimismo, tiene derecho a:
        </p>
        <ul>
          <li><strong>Acceso:</strong> conocer qué datos tenemos y cómo los tratamos.</li>
          <li><strong>Rectificación:</strong> modificar datos inexactos o incompletos.</li>
          <li><strong>Supresión ("derecho al olvido"):</strong> solicitar la eliminación de sus datos cuando concurra alguna de las circunstancias del art. 17 RGPD.</li>
          <li><strong>Limitación del tratamiento:</strong> solicitar la limitación del tratamiento de sus datos.</li>
          <li><strong>Oposición:</strong> oponerse al tratamiento de sus datos por motivos relacionados con su situación particular.</li>
          <li><strong>Portabilidad:</strong> recibir los datos personales en un formato estructurado y de uso común.</li>
        </ul>
        <p>
          Para ejercer estos derechos, envíe una solicitud escrita a <a href="mailto:info@mudanzasbritosa.com">info@mudanzasbritosa.com</a> o por correo postal a la dirección indicada, acompañando copia de su DNI o documento identificativo equivalente.
        </p>
        <p>
          Si considera que no hemos atendido debidamente el ejercicio de sus derechos, tiene derecho a presentar una reclamación ante la <a href="https://www.aepd.es" target="_blank" rel="noopener noreferrer">Agencia Española de Protección de Datos (AEPD)</a>.
        </p>

        <h2>6. Medidas de seguridad</h2>
        <p>
          Britosa Mudanzas aplica las medidas técnicas y organizativas apropiadas para garantizar un nivel de seguridad adecuado al riesgo del tratamiento, incluyendo el cifrado de comunicaciones mediante protocolo HTTPS, el acceso restringido a los datos y la revisión periódica de nuestras políticas de seguridad.
        </p>

        <h2>7. Cesiones de datos</h2>
        <p>
          No cedemos sus datos personales a terceros, salvo que sea necesario para la prestación del servicio contratado (por ejemplo, colaboradores logísticos en traslados internacionales) o cuando exista una obligación legal. En todo caso, dichas cesiones se realizarán con las garantías jurídicas pertinentes.
        </p>

        <h2>8. Uso de cookies</h2>
        <p>
          Este sitio utiliza cookies propias y de terceros para mejorar la experiencia de navegación, analizar el tráfico y personalizar contenido. Al continuar navegando, acepta su uso. Puede obtener más información en nuestra configuración de cookies o a través del banner inicial.
        </p>
      </div>
    </div>
  );
}
